import { useContext, useMemo, useState } from 'react'
import { MdDelete } from 'react-icons/md'
import { FiEdit } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import Table from './Table'
import useMutateData from '../../hooks/useMutateData'
import { authContext } from '../../context/auth-context'
import RenderIf from '../UI/RenderIf'
import ConfirmationModal from '../Modal/ConfirmationModal'
import viewFileApi from '../../services/viewFileApi'

const ViewFilesTable = ({ viewFiles = [] }) => {
  const [showModal, setShowModal] = useState(false)
  const [resourceId, setResourceId] = useState(null)
  const { token } = useContext(authContext)
  const { mutate: deleteViewFile, isLoading} = useMutateData({
    key: 'view-files',
    mutationFn: viewFileApi.deleteViewFile,
    successMessage: 'View File has been deleted successfully',
  })

  const onConfirmDelete = () => {
    deleteViewFile(
      { id: resourceId, token },
      {
        onSuccess: () => {
          setShowModal(false)
          setResourceId(null)
        },
      }
    )
  }

  const onDismissModal = () => {
    setShowModal(false)
    setResourceId(null)
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Id',
        accessor: 'id',
      },
      {
        Header: 'title',
        accessor: 'title',
      },
      {
        Header: 'slug',
        accessor: 'slug',
      },
      {
        Header: 'Actions',
        Cell: ({
          cell: {
            row: { original },
          },
        }) => {
          const { id, name } = original
          return (
            <div style={{ gap: '10px' }} className='d-flex align-items-center justify-content-end'>
              <Link to={`/view-file/edit-view-file/${id}`}>
                <FiEdit size={20} color='#B5B8BA' />
              </Link>
              <MdDelete
                cursor='pointer'
                color='#B5B8BA'
                size={22}
                onClick={() => {
                  setShowModal(true)
                  setResourceId(id)
                }}
              />
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <>
      <RenderIf isTrue={showModal}>
        <ConfirmationModal
          text='Are you sure you want to delete this view file?'
          onDismissModal={onDismissModal}
          onConfirmDelete={onConfirmDelete}
          isLoading={isLoading}
        />
      </RenderIf>
      <div>
        <Table columns={columns} data={viewFiles} />
      </div>
    </>
  )
}

export default ViewFilesTable
